import {notifications} from '@mantine/notifications'

import {DRIVER_SEND_STATUS} from '../dispatch-timeline/driver-send-status'
import {mintDriverLinks} from './api'
import type {DriverLink} from './schemas'

/** Returns false when the clipboard write fails. */
export async function copyDriverLinkToClipboard(link: DriverLink): Promise<boolean> {
    try {
        await navigator.clipboard.writeText(link.url)
    } catch {
        return false
    }
    notifications.show({
        title: `Link for ${link.workerName} copied`,
        message: DRIVER_SEND_STATUS.copiedLinkToastMessage,
        color: 'green',
    })
    return true
}

/** Returns the link when the clipboard write fails, otherwise null. */
export async function copyDriverJobLink(
    jobId: string,
    workerId: string,
): Promise<DriverLink | null> {
    const link = (await mintDriverLinks(jobId)).find((entry) => entry.workerId === workerId)
    if (!link) {
        throw new Error('Driver is no longer on this job')
    }
    return (await copyDriverLinkToClipboard(link)) ? null : link
}
